import React from 'react';
import { Card, CardContent } from './ui/card';
import { Quote } from 'lucide-react';
// Props: testimonials

const Testimonials = ({ testimonials }) => {
  if (!testimonials) return null;
  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Recommendations</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            What colleagues and mentors say
          </p>
          <div className="w-20 h-1 bg-blue-900 mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-1 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="border-2 border-blue-100 bg-blue-50/30 hover:shadow-lg transition-all">
              <CardContent className="p-8">
                <Quote className="w-10 h-10 text-blue-900 mb-4 opacity-50" />
                <p className="text-gray-700 text-base leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-200 to-blue-300 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-xl font-bold text-blue-900">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                    <p className="text-sm text-blue-900 font-medium">{testimonial.company}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
